import { useMemo } from 'react'

import { usePageInfo } from 'app/frontend/base/config/queries'

export const VISUAL_PLANS_MIN_SEASON_ID = 18

export const isVisualPlansEnabledForSeasonId = (seasonId?: number) =>
  seasonId !== undefined && seasonId >= VISUAL_PLANS_MIN_SEASON_ID

export const useVisualPlansEnabledForEncounter = (encounterId?: number) => {
  const {
    data: { currentExpansion },
  } = usePageInfo()

  const seasonId = useMemo(
    () =>
      currentExpansion.seasons.find((season) =>
        season.instances.some((instance) =>
          instance.encounters.some((encounter) => encounter.id === encounterId),
        ),
      )?.id,
    [currentExpansion, encounterId],
  )

  return isVisualPlansEnabledForSeasonId(seasonId)
}
